// extracted by mini-css-extract-plugin
export var blueLink = "AudWithdrawView-module--blueLink--f549d";
export var depositButton = "AudWithdrawView-module--depositButton--9a4e0";